export default {
  pageBank: {
    url: '/bank/pageBank',
  },
  listBankCorp: {
    url: '/bank/listBankCorp'
  },
  saveBankCorp: {
    url: '/bank/saveBankCorp'
  },
  updateBankCorp: {
    url: '/bank/updateBankCorp'
  },
  deleteBankCorp: {
    url: '/bank/deleteBankCorp'
  },
  saveBank: {
    url: '/bank/saveBank'
  },
  updateBank: {
    url: '/bank/updateBank'
  },
  downloadBankExcel: {
    url: '/bank/downloadBankExcel'
  },
  getBankByBankInfoId: {
    url: '/bank/getBankByBankInfoId'
  },
  deleteBank: {
    url: '/bank/deleteBank'
  },
}
